import { render, staticRenderFns } from "./seePlan.vue?vue&type=template&id=84a222fa&scoped=true&"
import script from "./seePlan.vue?vue&type=script&lang=js&"
export * from "./seePlan.vue?vue&type=script&lang=js&"
import style0 from "./seePlan.vue?vue&type=style&index=0&id=84a222fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a222fa",
  null
  
)

export default component.exports